import * as yup from "yup";

import { Currency } from "@krea/shared/types/common";

export const AmountValidation = (
  currency: Currency,
  formatWithCurrency: (value: number) => string,
) =>
  yup
    .number()
    .typeError("Amount is required")
    .required("Amount is required")
    .positive("Should be a positive number")
    .min(
      currency === Currency.SEK ? 1000 : 100,
      (schema) =>
        `Amount can't be lower than ${formatWithCurrency(schema.min)}`,
    )
    .max(
      1000 * 1000 * 1000,
      (schema) =>
        `Amount can't be greater than ${formatWithCurrency(schema.max)}`,
    );
